import { snapshot } from 'valtio'
import { locationPin } from '../locationPin'

export function getLocationPin(id: uui.domain.ui.map.LocationPinId, immutable: boolean = true) {
  const targetPin = locationPin.pins[id]
  return immutable && targetPin ? snapshot(targetPin) : targetPin
}
